import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import Event from '../../Components/Event';
import ConnectUserModal from '../../Components/ConnectUserModal';
import AcceptConnectUserModal from '../../Components/AcceptConnectUserModal';
import ErrorBoundary from '../../ErrorBoundary';

// email templates
var connectionModalButtons = document.querySelectorAll('[data-component=connection-button]')
var acceptConnectionModalButtons = document.querySelectorAll('[data-component=accept-connection-button]')

class ConnectButton extends Component {

    constructor(props) {
        super(props);
        this.state = { show: true };
    }

    fireModalEvent(e, modalName) {
        e.preventDefault();

        Event.fire(`${modalName}.show`, {
            firstname: this.props.firstname,
            lastname: this.props.lastname,
            access_uid: this.props.access_uid
        });
    }

    onHideButton() {
        this.setState({ show: false });
    }

    render() {

        if (!this.state.show || this.props.type != 1 || !window.loggedInUser || window.userConnections.indexOf(parseInt(this.props.access_uid)) >= 0) {
            return null;
        }

        return (
            <div style={{ marginLeft: "8px" }}>
                <a href="javascript:void(0)" onClick={(e) => this.fireModalEvent(e, 'connectUserModal')} className="btn btn-xs btn-primary">{this.props.title}</a>
                <ConnectUserModal onHideButton={() => this.onHideButton()} />
            </div>
        )
    }
}

class AcceptConnectButton extends Component {
    constructor(props) {
        super(props);
        this.state = { show: true };
    }

    fireModalEvent(e, modalName) {
        e.preventDefault();

        Event.fire(`${modalName}.show`, {
            firstname: this.props.firstname,
            lastname: this.props.lastname,
            access_uid: this.props.access_uid
        });
    }

    onHideButton() {
        this.setState({ show: false });
    }

    render() {
        if (!this.state.show || this.props.type != 1 || !window.loggedInUser || window.userRequestedConnections.indexOf(parseInt(this.props.access_uid)) == -1) {
            return null;
        }

        return (
            <div style={{ marginLeft: "12px" }}>
                <a href="javascript:void(0)" onClick={(e) => this.fireModalEvent(e, 'acceptConnectUserModal')} className="btn btn-xs btn-info">{this.props.title}</a>
                <AcceptConnectUserModal onHideButton={() => this.onHideButton()} />
            </div>
        )
    }
}

for (let key in connectionModalButtons) {
    if (connectionModalButtons.hasOwnProperty(key) && typeof connectionModalButtons[key].getAttribute === 'function') {
        let obj = connectionModalButtons[key];
        ReactDOM.render(
            <ErrorBoundary>
                <ConnectButton
                    firstname={obj.getAttribute('firstname')}
                    lastname={obj.getAttribute('lastname')}
                    access_uid={obj.getAttribute('access_uid')}
                    type={obj.getAttribute('type')}
                    title={obj.getAttribute('title')}
                />
            </ErrorBoundary>, obj);
    }
}

for (let key in acceptConnectionModalButtons) {
    if (acceptConnectionModalButtons.hasOwnProperty(key) && typeof acceptConnectionModalButtons[key].getAttribute === 'function') {
        let obj = acceptConnectionModalButtons[key];
        ReactDOM.render(
            <ErrorBoundary>
                <AcceptConnectButton
                    firstname={obj.getAttribute('firstname')}
                    lastname={obj.getAttribute('lastname')}
                    access_uid={obj.getAttribute('access_uid')}
                    type={obj.getAttribute('type')}
                    title={obj.getAttribute('title')}
                />
            </ErrorBoundary>, obj);
    }
}